document.addEventListener('DOMContentLoaded', quizInit);

function quizInit() {
  quiz();
}

function quiz() {
  const quizButtons = document.querySelectorAll('.quiz-btn');

  for (const button of quizButtons) {
    button.addEventListener('click', () => {
      const parent = button.parentElement;

      for (const sib of parent.querySelectorAll('.quiz-btn')) {
        sib.classList.remove('active');
      }

      button.classList.add('active');
    });
  }
}
